<!--审核拒绝原因-->
<template>
  <div>
    <e-dialog
      dialog-title="拒绝原因"
      :center-dialog-visible="visible"
      popup-width="600px"
      :show-btn="false"
      :show-close-btn="true"
      @resetPopupData="handleViewClose"
    >
      <div v-loading="loading" class="body-content">
        <span>拒绝原因：</span><span>{{ auditFeedback }}</span>
      </div>
    </e-dialog>
  </div>
</template>

<script>
import EDialog from '../../../components/common/e-dialog.vue';

export default {
  name: 'ApproveRefuseDialog',
  components: { EDialog },
  props: {},
  data() {
    return {
      auditFeedback: '',
      loading: false,
      visible: false,
    };
  },
  methods: {
    async initData(row) {
      this.auditFeedback = row.resultReason;
      this.visible = true;
    },
    // 关闭弹窗
    handleViewClose() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.body-content {
  display: flex;
  span:last-child {
    flex: 1;
  }
}
</style>
